import { Component, OnInit } from '@angular/core';

// 以下追加したもの
import { Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';


export class SignUpInfoSet {
  constructor(public fullName: string, public key: string, public secret: string) { }
}

@Component({
  selector: 'app-user-signup',
  templateUrl: './user-signup.component.html',
  styleUrls: ['./user-signup.component.css']
})
export class UserSignUpComponent implements OnInit {
  keySet = new SignUpInfoSet('', '', '');
  hide = true;

  constructor(
    private router: Router,
    private auth: AuthService
  ) {
  }
  ngOnInit() { }
  onSubmit() {
    // this.signup();
  }

  // signup() {
  //   const email = this.keySet.key;
  //   const password = this.keySet.secret;
  //   const name = this.keySet.fullName;
  //   this.auth.signUp(email, password, name)
  //     .then((x) => {
  //       this.router.navigate(['/']);
  //     });
  // }
}
